"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECORD_POSTING_EVENT_RESPONSE_EXAMPLE = void 0;
var financial_common_response_1 = require("./financial-common.response");
Object.defineProperty(exports, "RECORD_POSTING_EVENT_RESPONSE_EXAMPLE", { enumerable: true, get: function () { return financial_common_response_1.FIN_POSTING_EVENT_LOG_RESPONSE_EXAMPLE; } });
//# sourceMappingURL=financial-posting.response.js.map